module.exports = __webpack_public_path__ + "img/effect.ff84c67c.png";